import { createClient } from "@supabase/supabase-js";

// ─── SUPABASE ─────────────────────────────────────────────────────────────────
const SUPABASE_URL = "https://eeowlamcuajbxcjwwzpk.supabase.co";
const SUPABASE_ANON_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVlb3dsYW1jdWFqYnhjand3enBrIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzM0OTQyNzMsImV4cCI6MjA4OTA3MDI3M30.kqvtrvHqPrX-Mvu5m251_ZUiLxV_fF7WspOqZnlM6JM";
export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);

export const saveCandidateToSupabase = async (candidate, positionId, clientId = null) => {
  const { error } = await supabase.from("candidates").upsert({
    id: candidate.id,
    position_id: positionId,
    client_id: clientId,
    name: candidate.name || "",
    company: candidate.company || "",
    current_position: candidate.position || "",
    city: candidate.city || "",
    salary: candidate.salary || "",
    notice: candidate.notice || "",
    years_experience: candidate.yearsExperience ?? null,
    phone: candidate.phone || "",
    email: candidate.email || "",
    linkedin: candidate.linkedin || "",
    app_date: candidate.appDate || "",
    status: candidate.status || "pending",
    scoring: candidate.scoring || {},
    verdict: candidate.verdict || "",
    strengths: candidate.strengths || [],
    weaknesses: candidate.weaknesses || [],
    qual_sections: candidate.qualSections || [],
    refs_data: candidate.refsData || [],
    references_count: candidate.references || 0,
  });
  if (error) console.error("Error saving candidate to Supabase:", error);
  return { error };
};

// ─── AUTH ─────────────────────────────────────────────────────────────────────
// Admin emails — anyone in this list has full access (sees all clients, all data)
export const ADMIN_EMAILS = ["borja@rutment.com", "borjaafanderibera@gmail.com"];

// Backwards compatibility — kept for child components still importing these
export const ADMIN_EMAIL = "borja@rutment.com";
export const GUEST_EMAIL = "guest@rutment.com";
export const COMPANY_LOGO = "";

// Returns true if the given email belongs to an admin user
export const isAdmin = (email) => !!email && ADMIN_EMAILS.includes(email);

// Returns the list of client_ids associated with a user (via user_clients table)
// Returns [] if user has no associations or query fails
export const loadUserClients = async (userId) => {
  if (!userId) return [];
  const { data, error } = await supabase
    .from("user_clients")
    .select("client_id")
    .eq("user_id", userId);
  if (error || !data) {
    console.error("Error loading user_clients:", error);
    return [];
  }
  return data.map(row => row.client_id);
};

// ─── PALETA — LA ÚNICA (31/10) ───────────────────────────────────────────────
// Toda la web sale de aquí: 1 marca con sus tonos, 11 neutros, estado y datos.
// GEMELA de lib/theme.js del portal (mismos nombres y valores).
// Un color que no esté aquí no existe: ESLint marca cualquier "#xxx" escrito
// fuera de este archivo (regla de package.json). Si de verdad hace falta uno
// nuevo, se añade AQUÍ, en theme.js y en DESIGN_SYSTEM.md, en el mismo cambio.
// Marca: solo lo pulsable
export const BRAND = "#3E3EF8";
export const BRAND_LIGHT = "#EBEBFF";  // fondo del estado activo, botón suave
export const BRAND_DARK = "#2828C8";   // botón principal al pasar el ratón
export const HOVER_BG = "#FAFAFF";     // fila o tarjeta pulsable al pasar el ratón
export const HOVER_LINE = "#DADAF5";   // su borde al pasar, o pieza fijada
// Neutros, de claro a oscuro
export const WHITE = "#FFFFFF";        // tarjetas, controles
export const BG = "#F7F7FB";           // fondo de la aplicación
export const DARK = "#0E0E12";         // landing y pantallas de entrada

// ─── TOKENS DE DISEÑO ────────────────────────────────────────────────────────
// GEMELO de `src/lib/theme.js` en el portal. Los dos archivos deben cambiarse
// A LA VEZ: son repos distintos y no hay forma de compartir uno solo sin montar
// un paquete npm, que es infraestructura que mantener para un proyecto de una
// persona. Mismo criterio que CLAUDE.md o DESIGN_SYSTEM.md.
//
// POR QUÉ EXISTE: `DESIGN_SYSTEM.md` no impide nada — es un documento que hay
// que acordarse de abrir. Cada pantalla escrita de golpe acababa inventando
// valores parecidos pero distintos (12.5 en vez de 13, #AAA en vez de #888).
//
// REGLA: en un componente no se escribe un fontSize a mano. Se usa `text.*`.
// Si hace falta un valor que no está aquí, se AÑADE AQUÍ primero.

// Grises. Un solo valor por función: los casi iguales (#E5E5E5, #999, #333,
// #F5F5F5…) se fundieron aquí el 31/10.
export const INK = "#111";     // texto principal, cifras
export const TEXT = "#555";    // texto secundario, iconos
export const MUTED = "#888";   // metadatos, etiquetas, marcadores de posición
export const FAINT = "#BBB";   // vacíos, desactivados, puntos neutros
export const LINE = "#EFEFEF"; // bordes de tarjetas y controles
export const ROW_LINE = "#F3F3F3";   // separador entre filas dentro de una tarjeta
export const NEUTRAL_BG = "#F0F0F5"; // rieles, chips, avatares sin foto, desactivados
export const SURFACE = "#FAFAFA";    // caja interior, cabecera de tabla
// Estado
export const DANGER = "#BE123C";
export const DANGER_BG = "#FFF1F2";
export const DANGER_LINE = "#FECDD3";
export const UNREAD = "#EF4444";     // solo el contador de avisos (unreadBadge)
export const STAR = "#F5B301";       // destacados del usuario

// Verde de marca. GREEN es muy claro (1.4:1 sobre blanco): vale para puntos,
// barras y rellenos, NUNCA para texto. Para texto verde, GREEN_TEXT.
export const GREEN = "#00F6B0";
export const GREEN_TEXT = "#00875F";
export const GREEN_BG = "#E6FEF7";

// Sombras: cuatro, por altura. Y el fondo oscurecido de las ventanas.
export const SHADOW_SM = "0 1px 3px rgba(17,17,17,0.06)";      // tarjeta levantada
export const SHADOW_POP = "0 12px 32px rgba(17,17,17,0.12)";   // menús y ventanitas
export const SHADOW_MODAL = "0 24px 64px rgba(17,17,17,0.20)"; // ventanas
export const SHADOW_PANEL = "-12px 0 32px rgba(17,17,17,0.08)"; // panel lateral
export const SCRIM = "rgba(17,17,17,0.45)";        // fondo oscurecido de ventanas
export const SCRIM_PHOTO = "rgba(14,14,18,0.85)";  // foto ampliada o recorte
export const SHADOW_SHEET = "0 -8px 32px rgba(17,17,17,0.12)"; // hoja inferior del móvil

// ── Datos: SOLO gráficos (mapa, barras de perfil), nunca botones ni estados ──
// Arquetipos (Arquitecto, Catalizador, Conector, Guardián): color fuerte, y los
// pastel del mapa. GEMELOS de theme.js del portal
export const ARCH_COLORS = ["#3E3EF8", "#8B5CF6", "#D85A30", "#1D9E75"];
export const ARCH_QUAD_FILLS = ["#E4E9FC", "#F1E8FF", "#FAECE7", "#E1F5EE"];
export const ARCH_QUAD_TEXT = ["#26215C", "#5B21B6", "#712B13", "#085041"];
// Barras del perfil de cultura (31/10): un pastel por dimensión, de la misma
// familia que el mapa de Archetypes pero un punto más intenso para leerse sobre
// el riel NEUTRAL_BG. Solo rellenos, nunca texto. Gemelo en theme.js del portal.
export const CULTURE_COLORS = {
  speed: "#C9B8F5", autonomy: "#B8C6F5", standards: "#F2C1AE",
  growth: "#A9DEC8", candor: "#F5D59A", risk: "#EBB8CF",
};

export const text = {
  h1:        { fontSize: 26, fontWeight: 800, color: INK, letterSpacing: -0.5 },
  pageSub:   { fontSize: 13, fontWeight: 400, color: MUTED },
  h2:        { fontSize: 16, fontWeight: 800, color: INK },
  cardTitle: { fontSize: 15, fontWeight: 800, color: INK },
  cardSub:   { fontSize: 12, fontWeight: 400, color: MUTED },
  body:      { fontSize: 13, fontWeight: 400, color: TEXT, lineHeight: 1.6 },
  bodySm:    { fontSize: 12, fontWeight: 400, color: TEXT, lineHeight: 1.6 },
  label:     { fontSize: 11, fontWeight: 700, color: MUTED, textTransform: "uppercase", letterSpacing: 0.4 },
  meta:      { fontSize: 11, fontWeight: 500, color: MUTED },
  empty:     { fontSize: 11, fontWeight: 500, color: FAINT },
  // Cifra destacada (22/10): el dato del reverso de una credencial
  stat:      { fontSize: 30, fontWeight: 800, color: INK, letterSpacing: -0.5, lineHeight: 1.1 },
};

// Contador rojo de avisos: la ÚNICA versión (15/10), gemela de unreadBadge en
// theme.js del portal. Crece con el número; antes había siete versiones, y las
// de ancho fijo (14 o 16) descentraban "12".
export const unreadBadge = { background: UNREAD, color: WHITE, borderRadius: 999, fontSize: 10, fontWeight: 700, minWidth: 18, height: 18, padding: '0 5px', boxSizing: 'border-box', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', lineHeight: 1, fontVariantNumeric: 'tabular-nums', flexShrink: 0, fontFamily: 'inherit' };

// Título de página: el mismo en todas las pantallas (15/10). Sin margen arriba,
// para que al pasar de una pantalla a otra el título no salte; mb = espacio debajo.
export const pageTitle = (isMobile, mb = 0) => ({ ...text.h1, fontSize: isMobile ? 22 : 26, margin: `0 0 ${mb}px`, lineHeight: 1.2 });

// Una línea con puntos suspensivos. Sin minWidth 0 los hijos de un grid no
// truncan: es la causa más común de tablas descuadradas.
export const oneLine = {
  minWidth: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap",
};

export const card = {
  background: WHITE, border: `1.5px solid ${LINE}`, borderRadius: 14, padding: 22,
};

// Todos los controles comparten alto, fuente y radio. `fontFamily: inherit` es
// obligatorio: un <select> sin él hereda la fuente del sistema.
const controlBase = {
  height: 38, boxSizing: "border-box", border: `1.5px solid ${LINE}`,
  borderRadius: 8, fontSize: 13, fontWeight: 500, fontFamily: "inherit",
  color: TEXT, background: WHITE, outline: "none",
};

export const input = { ...controlBase, width: "100%", padding: "0 13px" };
export const textareaStyle = {
  ...controlBase, width: "100%", height: "auto", padding: "11px 13px",
  resize: "vertical", lineHeight: 1.6,
};
export const selectStyle = { ...controlBase, padding: "0 12px", cursor: "pointer" };

// `primary` para la acción principal, `soft` para la secundaria de marca,
// `ghost` para la alternativa neutra, `danger` SOLO para lo irreversible.
// Nunca dos botones de color en el mismo bloque.
export const btn = {
  primary:  { background: BRAND, color: WHITE, border: "none", borderRadius: 8, padding: "9px 18px", fontWeight: 700, fontSize: 13, fontFamily: "inherit", cursor: "pointer" },
  soft:     { background: BRAND_LIGHT, color: BRAND, border: "none", borderRadius: 8, padding: "9px 18px", fontWeight: 700, fontSize: 13, fontFamily: "inherit", cursor: "pointer" },
  ghost:    { background: WHITE, color: TEXT, border: `1.5px solid ${LINE}`, borderRadius: 8, padding: "9px 18px", fontWeight: 600, fontSize: 13, fontFamily: "inherit", cursor: "pointer" },
  danger:   { background: DANGER, color: WHITE, border: "none", borderRadius: 8, padding: "9px 18px", fontWeight: 700, fontSize: 13, fontFamily: "inherit", cursor: "pointer" },
  disabled: { background: NEUTRAL_BG, color: FAINT, border: "none", borderRadius: 8, padding: "9px 18px", fontWeight: 700, fontSize: 13, fontFamily: "inherit", cursor: "not-allowed" },
};

export const chip = (on = false) => ({
  fontSize: 11, fontWeight: 700, padding: "3px 9px", borderRadius: 999,
  background: on ? BRAND_LIGHT : NEUTRAL_BG, color: on ? BRAND : TEXT,
  fontFamily: "inherit",
});

export const pillStyle = (on = false, disabled = false) => ({
  padding: "7px 14px", borderRadius: 20,
  border: `1.5px solid ${on ? BRAND : LINE}`,
  background: on ? BRAND_LIGHT : WHITE,
  color: on ? BRAND : disabled ? FAINT : TEXT,
  // El peso no cambia al activarse (DESIGN_SYSTEM.md): si cambia, la píldora
  // se ensancha y empuja a las de al lado.
  fontSize: 13, fontWeight: 600, fontFamily: "inherit",
  cursor: disabled ? "not-allowed" : "pointer",
});

// ─── PIEZAS COMUNES (15/10): gemelas de lib/theme.js del portal ───────────────
// Antes cada pantalla de rutment.com hacía a mano sus botones, enlaces, cierres
// y avisos, con medidas y colores distintos para lo mismo. Ninguna pantalla
// nueva escribe estos estilos a mano: los toma de aquí.
export const cardFlush = { ...card, padding: 0, overflow: "hidden" };
export const btnSm = { padding: "6px 12px", fontSize: 12 };
// Enlace de acción: azul, negrita, sin caja
export const linkBtn = { background: "none", border: "none", padding: 0, cursor: "pointer", fontFamily: "inherit", fontSize: 12, fontWeight: 700, color: BRAND };
// Botón de solo icono (cerrar, menú…): gris, sin fondo
export const iconBtn = { width: 32, height: 32, display: "inline-flex", alignItems: "center", justifyContent: "center", background: "transparent", border: "none", borderRadius: 8, color: MUTED, cursor: "pointer", flexShrink: 0, padding: 0, lineHeight: 0 };
// Errores: texto rojo de marca, y una sola caja para los avisos de error
export const errorText = { fontSize: 12, color: DANGER, lineHeight: 1.5 };
export const errorBanner = { background: DANGER_BG, border: `1.5px solid ${DANGER_LINE}`, borderRadius: 10, padding: "10px 14px", fontSize: 13, color: DANGER, lineHeight: 1.5 };
// "✓ Guardado": la única confirmación en verde, y siempre igual
export const savedText = { fontSize: 12, fontWeight: 600, color: GREEN_TEXT };
// Conmutador de pestañas: contenedor gris, activa en blanco con texto azul; el
// peso no cambia al activarse
export const segWrap = { display: "flex", gap: 4, background: NEUTRAL_BG, borderRadius: 10, padding: 4 };
export const segBtn = (on) => ({ border: "none", borderRadius: 8, padding: "7px 14px", fontSize: 13, fontWeight: 600, fontFamily: "inherit", cursor: "pointer", whiteSpace: "nowrap", color: on ? BRAND : TEXT, background: on ? WHITE : "transparent", boxShadow: on ? "0 1px 3px rgba(0,0,0,0.08)" : "none" });

// ─── TRANSLATIONS ─────────────────────────────────────────────────────────────
export const translations = {
  en: {
    hi: "Hi",
    newPosition: "New position",
    openPositions: "Open positions",
    closedPositions: "Closed positions",
    beginSearch: "Begin the search!",
    requestRefReport: "Reference reports",
    support: "Support",
    subscription: "Subscription",
    manageAccount: "Manage account",
    openNewPosition: "Open new position",
    newRefReport: "New reference report",
    createCultureDoc: "Create culture document",
    redoCultureDoc: "Redo culture document",
    cultureDocDesc: "Define your company culture for candidates",
    tips: "Tips",
    candidates: "Candidates",
    name: "Name",
    position: "Position",
    company: "Company",
    appDate: "App. date",
    docs: "Docs",
    validate: "Validate",
    reject: "Reject",
    status: "Status",
    pending: "Pending",
    approved: "Approved",
    rejected: "Rejected",
    cv: "CV",
    report: "Report",
    processMetrics: "Metrics",
    dateOpening: "Date opening",
    liveCandidates: "Live",
    reviewed: "Reviewed",
    considered: "Considered",
    interested: "Interested",
    qualified: "Qualified",
    validated: "Validated",
    qualification: "Qualification",
    rutmentScoring: "Rutment scoring",
    references: "References",
    coincidingPoints: "Coinciding points",
    technicalFit: "Technical fit",
    softSkills: "Soft skills",
    culturalFit: "Cultural fit",
    growthPotential: "Growth potential",
    strengths: "Key strengths",
    weaknesses: "Potential weaknesses",
    finalVerdict: "Final verdict",
    prioritize: "Prioritize and advance quickly",
    likelihood: "likelihood",
    jobDesc: "Job description",
    positionName: "Position name",
    hardSkills: "Hard skills",
    softSkillsLabel: "Soft skills",
    culture: "Culture (values/aptitudes)",
    experience: "Experience (years)",
    mainTasks: "Main tasks",
    preferredBg: "Preferred background",
    sampleProfile: "Sample profile (LinkedIn URL)",
    salaryRange: "Salary range",
    whatsCool: "What's cool about this role?",
    perks: "Perks & other benefits",
    careerPath: "Career path (if any)",
    reportingTo: "Reporting to",
    directReports: "Direct reports",
    theProcess: "The process",
    hiringManager: "Hiring manager",
    offLimits: "Off limits",
    evaluation: "Evaluation",
    preEvaluation: "Pre-evaluation",
    interviewers: "Interviewers",
    interviewer: "Interviewer",
    continue: "Continue",
    back: "Back",
    confirm: "Confirm position?",
    requestSent: "Your request has been submitted. You will receive an email once reviewed by our team. Thanks!",
    shareWithCandidate: "Share with candidate",
    good: "Good",
    enterAnswer: "Enter your answer",
    addLinkedin: "Add LinkedIn URL",
    enterEmail: "Enter email",
    selectTemplate: "Select template",
    enterCandidateName: "Enter candidate or company (off limits)",
    requestRefInLastStage: "Request reference report in last stage prior to offer?",
    goNoGo: "Go / No-go",
    personalData: "Personal data",
    currentSalary: "Current salary / expectation",
    noticePeriod: "Notice period",
    city: "City",
    dashboard: "Home",
    yes: "Yes",
    no: "No",
    later: "Later",
    sendEmailNow: "Send email now?",
    signOffCandidate: "Sign off candidate?",
    addPosition: "Add position",
    search: "Search",
    filter: "Filter",
    of: "of",
    action: "ACTION",
    coincidingPointsTitle: "Coinciding points",
    pointsWhereBothAgree: "Points where both referees agree",
    verdictLabel: "Summary",
    noReferencesYet: "No references yet",
    willAppearSecondRef: "Will appear once a second reference is received",
    compareWith: "Compare with:",
    candidateAverage: "Candidate average",
    tabComparison: "Comparison",
    tabCV: "CV",
  },
  es: {
    hi: "Hola",
    newPosition: "Nueva posición",
    openPositions: "Posiciones abiertas",
    closedPositions: "Posiciones cerradas",
    beginSearch: "¡Comenzar búsqueda!",
    requestRefReport: "Informes de referencias",
    support: "Soporte",
    subscription: "Suscripción",
    manageAccount: "Gestionar cuenta",
    openNewPosition: "Abrir nueva posición",
    newRefReport: "Nuevo informe de referencias",
    createCultureDoc: "Crear documento de cultura",
    redoCultureDoc: "Rehacer documento de cultura",
    cultureDocDesc: "Define la cultura de tu empresa para candidatos",
    tips: "Consejos",
    candidates: "Candidatos",
    name: "Nombre",
    position: "Posición",
    company: "Empresa",
    appDate: "Fecha",
    docs: "Docs",
    validate: "Validar",
    reject: "Rechazar",
    status: "Estado",
    pending: "Pendiente",
    approved: "Aprobado",
    rejected: "Rechazado",
    cv: "CV",
    report: "Informe",
    processMetrics: "Métricas",
    dateOpening: "Fecha apertura",
    liveCandidates: "Activos",
    reviewed: "Revisado",
    considered: "Considerados",
    interested: "Interesados",
    qualified: "Cualificados",
    validated: "Validados",
    qualification: "Cualificación",
    rutmentScoring: "Puntuación Rutment",
    references: "Referencias",
    coincidingPoints: "Puntos coincidentes",
    technicalFit: "Fit técnico",
    softSkills: "Soft skills",
    culturalFit: "Fit cultural",
    growthPotential: "Potencial de crecimiento",
    strengths: "Fortalezas clave",
    weaknesses: "Posibles debilidades",
    finalVerdict: "Veredicto final",
    prioritize: "Priorizar y avanzar rápido",
    likelihood: "probabilidad",
    jobDesc: "Descripción del puesto",
    positionName: "Nombre del puesto",
    hardSkills: "Hard skills",
    softSkillsLabel: "Soft skills",
    culture: "Cultura (valores/aptitudes)",
    experience: "Experiencia (años)",
    mainTasks: "Tareas principales",
    preferredBg: "Perfil preferido",
    sampleProfile: "Perfil de ejemplo (URL LinkedIn)",
    salaryRange: "Rango salarial",
    whatsCool: "¿Qué tiene de especial este rol?",
    perks: "Beneficios y otros",
    careerPath: "Plan de carrera (si aplica)",
    reportingTo: "Reporta a",
    directReports: "Reportes directos",
    theProcess: "El proceso",
    hiringManager: "Hiring manager",
    offLimits: "Off limits",
    evaluation: "Evaluación",
    preEvaluation: "Pre-evaluación",
    interviewers: "Entrevistadores",
    interviewer: "Entrevistador",
    continue: "Continuar",
    back: "Atrás",
    confirm: "¿Confirmar posición?",
    requestSent: "Tu solicitud ha sido enviada. Recibirás un email de confirmación cuando sea revisada. ¡Gracias!",
    shareWithCandidate: "Compartir con candidato",
    good: "Bueno",
    enterAnswer: "Introduce tu respuesta",
    addLinkedin: "Añadir URL de LinkedIn",
    enterEmail: "Introduce email",
    selectTemplate: "Seleccionar plantilla",
    enterCandidateName: "Introduce candidato o empresa (off limits)",
    requestRefInLastStage: "¿Solicitar informe de referencias en la última fase antes de la oferta?",
    goNoGo: "Go / No-go",
    personalData: "Datos personales",
    currentSalary: "Salario actual / expectativa",
    noticePeriod: "Preaviso",
    city: "Ciudad",
    dashboard: "Home",
    yes: "Sí",
    no: "No",
    later: "Más tarde",
    sendEmailNow: "¿Enviar email ahora?",
    signOffCandidate: "¿Dar el visto bueno al candidato?",
    addPosition: "Añadir posición",
    search: "Buscar",
    filter: "Filtrar",
    of: "de",
    action: "ACCIÓN",
    coincidingPointsTitle: "Puntos coincidentes",
    pointsWhereBothAgree: "Puntos en los que ambos referentes coinciden",
    verdictLabel: "Resumen",
    noReferencesYet: "Aún no hay referencias",
    willAppearSecondRef: "Aparecerá cuando se reciba una segunda referencia",
    compareWith: "Comparar con:",
    candidateAverage: "Media candidatos",
    tabComparison: "Comparación",
    tabCV: "CV",
  },
};

// ─── SCORING PROMPT ───────────────────────────────────────────────────────────
export const SCORING_PROMPT = `You are a senior executive recruiter scoring a candidate for a specific role.

SCORING SCALE: 1=Very weak, 2=Below expectations, 3=Meets expectations, 4=Above expectations, 5=Exceptional

SCORE 4 BUCKETS based on the candidate responses mapped to these question numbers:

BUCKET 1 — Technical Skills (score: "technical")
Source: questions 2.1, 2.2, 2.3, 2.4
Criteria: Has the candidate exercised exactly this role before? Depth of sector knowledge and relevant network? Mastery of critical tools or methodologies? Technical strengths that generate immediate impact? Evidence of plug-and-play readiness?

BUCKET 2 — Soft Skills (score: "soft")
Source: questions 3.1, 3.2, 3.3, 3.4. Secondary input: 4.1
Criteria: Leadership, empathy, initiative, resilience, hunger, emotional intelligence, communication, conflict management, authenticity. Match between soft skills required in the JD and concrete evidence provided.

BUCKET 3 — Cultural Fit (score: "cultural")
Source: questions 3.1, 4.1, 4.2
Criteria: Alignment with company culture document (values, leadership style, team type, founders background). Match between what the candidate seeks and what the company offers.

BUCKET 4 — Growth & Potential (score: "growth")
Source: transversal — especially 3.2, 4.2, and implicit signals across all responses
Criteria (Fernández-Aráoz framework): intrinsic motivation, curiosity, insight, engagement, determination. Evidence of adaptability, learning new roles, managing diverse responsibilities, intellectual curiosity beyond day-to-day.

IMPORTANT: Questions 1.1–1.4 are personal data only — do not score them.
Questions 4.3 and 4.4 are personal profile — include in report but do not affect scoring.

Generate:
- scoring: object with technical, soft, cultural, growth (each 1-5)
- strengths: array of exactly 3 key strengths with concrete evidence from responses
- weaknesses: array of exactly 3 areas for improvement or concerns
- verdict: match percentage as string e.g. "75-80%"
- summary: 2 sentences max — candidate fit summary for this specific role

Respond ONLY with valid JSON, no markdown, no explanation:
{
  "scoring": { "technical": 4, "soft": 3, "cultural": 4, "growth": 4 },
  "strengths": ["strength 1", "strength 2", "strength 3"],
  "weaknesses": ["weakness 1", "weakness 2", "weakness 3"],
  "verdict": "72-78%",
  "summary": "Candidate summary here."
}`;

// Listados paginados: Supabase corta en 1.000 filas sin avisar (CLAUDE.md,
// regla 1). La consulta que se pasa debe llevar .order() fijo: sin él, las
// páginas pueden repetir o saltarse filas. Fuente única (24/10).
export const fetchAll = async (build) => {
  const out = [];
  for (let from = 0; ; from += 1000) {
    const { data, error } = await build().range(from, from + 999);
    if (error) throw error;
    out.push(...(data || []));
    if (!data || data.length < 1000) break;
  }
  return out;
};
